export const mainnav = async (err) => {
  if (err) {
    console.error(err);
  }

  /*
   * Show mainmenu on menu link click
   */

  const menuOpenLink = document.getElementById('main-menu-open-link'),
    htmlTag = document.getElementsByTagName('html')[0],
    pageHeader = document.getElementsByTagName('header')[0],
    brandLogo = document.getElementsByClassName('brand-logo')[0],
    menuCloseLink = document.getElementsByClassName('main-menu-close-link')[0],
    navPrimary = document.getElementsByClassName('nav-primary')[0],
    submenuBackLink = document.getElementsByClassName('sub-menu-back-link')[0];
  if (menuOpenLink) {
    const getScrollbarWidth = () =>
      window.innerWidth - document.documentElement.clientWidth;
    menuOpenLink.addEventListener('click', (e) => {
      navPrimary.classList.add('mainmenu--open');

      if (pageHeader.classList.contains('fixed-header')) {
        menuCloseLink.style.marginTop = 29 + 'px';
      }
      if (htmlTag.querySelector('.current-menu-ancestor')) {
        htmlTag.classList.add('submenu-open');
      }
      setTimeout(() => {
        // hide contents jumping
        htmlTag.style.right = getScrollbarWidth() + 'px';
        brandLogo.style.right = -(getScrollbarWidth() / 2) + 'px';
        htmlTag.classList.add('nav-open');
        pageHeader.classList.remove('move-right');
      }, 300);

      e.preventDefault();
    });
  }

  /*
   * Close mainmenu on click schliessen link
   */

  if (menuCloseLink) {
    menuCloseLink.addEventListener('click', (e) => {
      if (pageHeader.classList.contains('fixed-header')) {
        setTimeout(() => {
          menuCloseLink.removeAttribute('style');
        }, 600);
      }

      pageHeader.classList.add('hide-meta-nav-text');

      setTimeout(() => {
        pageHeader.classList.add('move-right');

        htmlTag.classList.remove('nav-open');

        htmlTag.removeAttribute('style');

        brandLogo.removeAttribute('style');

        navPrimary.classList.remove('mainmenu--open');
        pageHeader.classList.remove('hide-meta-nav-text');
      }, 300);

      e.preventDefault();
    });
  }

  /*
   * Submenu backlink on mobile
   */
  if (submenuBackLink) {
    if (document.getElementsByClassName('current-menu-ancestor)')[0]) {
      submenuBackLink.style.visibility = 'visible';
    }
    submenuBackLink.addEventListener('click', (e) => {
      e.preventDefault();
      if (document.getElementsByClassName('submenu--open')[0]) {
        document
          .getElementsByClassName('submenu--open')[0]
          .classList.remove('submenu--open');
      }

      if (document.getElementsByClassName('submenu-open')[0]) {
        document
          .getElementsByClassName('submenu-open')[0]
          .classList.remove('submenu-open');
      }

      document
        .getElementsByClassName('current-menu-ancestor')[0]
        .classList.remove('current-menu-ancestor');
      document
        .getElementsByClassName('current-menu-parent')[0]
        .classList.remove('current-menu-parent');
    });
  }

  /*
   * Open submenu on top level menu item click
   */
  var menuItems = document.querySelectorAll('.nav > .menu-item-has-children');
  // check if html element contains id blog-5 (pradaschier theme)
  if (document.getElementById('blog-5')) {
    menuItems = document.querySelectorAll('.nav > .menu-item-has-children > a');
  }

  menuItems.forEach((item) => {
    if (item.querySelector('.current-posttype-page-parent')) {
      document.getElementsByTagName('html')[0].classList.add('submenu-open');
      item.classList.add('submenu--open');
    }

    item.addEventListener('click', (e) => {
      item.classList.toggle('submenu--open');

      if (item.classList.contains('submenu--open')) {
        document.getElementsByTagName('html')[0].classList.add('submenu-open');
      } else {
        document
          .getElementsByTagName('html')[0]
          .classList.remove('submenu-open');
      }

      // remove class from all siblings
      let siblings = item.parentElement.children;
      for (let i = 0; i < siblings.length; i++) {
        if (siblings[i] !== item) {
          siblings[i].classList.remove('submenu--open');
          siblings[i].classList.remove('current-menu-parent');
        }
      }

      e.preventDefault();
    });
  });
  /*
   * enable click on submenu items
   */
  const subMenuItems = document.querySelectorAll(
    '.menu-item-has-children .sub-menu .menu-item',
  );
  subMenuItems.forEach((item) => {
    item.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  });

  /*
   * Show sticky navigation on scroll
   */

  shrinkNavHeaderOnScroll();

  function shrinkNavHeaderOnScroll() {
    var lastScrollTop, // This Varibale will store the top position
      navbar = document.getElementsByClassName('banner')[0];
    //var scrollTopOnLoad = window.pageYOffset || document.documentElement.scrollTop;
    // fixed header class if page pos is further down on pageload
    if (window.pageYOffset || document.documentElement.scrollTop > 300) {
      navbar.classList.add('fixed-header');
    }
    if (window.pageYOffset || document.documentElement.scrollTop > 600) {
      navbar.classList.add('move-right');
    }

    window.addEventListener('scroll', function () {
      //on every scroll this funtion will be called
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > lastScrollTop && scrollTop > 300) {
        //if it will be greater than the previous

        navbar.classList.add('fixed-header');

        //set the value to the negative of height of navbar
      }
      if (scrollTop > lastScrollTop && scrollTop > 400) {
        navbar.classList.add('move-right');
        // move this navbar to the right
        // navbar.style.right = window.innerWidth
      }
      if (scrollTop <= 400) {
        navbar.classList.remove('move-right');
      }
      if (scrollTop <= 300) {
        navbar.classList.remove('fixed-header');
      }
      lastScrollTop = scrollTop; //New Position Stored
    });
  }

  /*
   * Pradaschier Hamburger menu
   */
  /*
   * Show mainmenu on menu click
   */
  const menuToggle = document.getElementById('input__menu-toggle');
  let isNavOpen = false;
  if (menuToggle) {
    menuToggle.addEventListener('click', (e) => {
      htmlTag.classList.toggle('nav-open');
      navPrimary.classList.toggle('mainmenu--open');

      if (!isNavOpen) {
        isNavOpen = true;
      } else {
        isNavOpen = false;
      }
      e.preventDefault();
    });
  }
};

import.meta.webpackHot?.accept(mainnav);
